import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { listSearchSchema } from '@/lib/list-search-schema';
import Jobs from '@/pages/Jobs';

export const jobsSearchSchema = listSearchSchema.extend({
  status: z.string().optional(),
  category: z.string().optional(),
});

export type JobsSearch = z.infer<typeof jobsSearchSchema>;

export const Route = createFileRoute('/_authenticated/jobs/')({
  validateSearch: jobsSearchSchema,
  component: Jobs,
});
